/* ==========================================================================
   SILETH 2.0 - Verhalten ueber Prestige 11.4.1
   1. Lieferfenster als echte Daten
   2. Videos: Quelle erst bei Sichtbarkeit setzen, nur passende Bildschirmgroesse
   3. Bewertungen: grosse Ansicht
   4. Sanftes Scrollen zu Ankern (Sterne -> Bewertungen)
   Gratis-Schmuckstueck: assets/sileth-cart.js
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     1. Lieferfenster als Datum (Werktage, Wochenende uebersprungen)
     ------------------------------------------------------------------------ */
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    var added = 0;
    while (added < n) {
      r.setDate(r.getDate() + 1);
      var wd = r.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return r;
  }
  function paintDelivery() {
    document.querySelectorAll('[data-s-delivery]:not([data-done])').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      var loc = el.getAttribute('data-locale') === 'de' ? 'de-DE' : 'en-GB';
      var out = el.querySelector('[data-s-delivery-window]');
      if (!out || !min || !max) return;
      try {
        // Zeit in Muenchen: nach 14 Uhr oder am Wochenende zaehlt der naechste Werktag als Start
        var now = new Date();
        var berlin = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
        var start = new Date(berlin.getTime());
        var wd = start.getDay();
        if (wd === 6 || wd === 0 || start.getHours() >= 14) {
          start = addBusinessDays(start, 1);
        }
        var a = addBusinessDays(start, min);
        var b = addBusinessDays(start, max);
        var fmtDay = new Intl.DateTimeFormat(loc, { weekday: 'short', day: 'numeric', month: 'short' });
        var txt = fmtDay.format(a).replace(/\.$/, '') + ' – ' + fmtDay.format(b).replace(/\.$/, '');
        out.textContent = txt;
        el.setAttribute('data-done', '1');
      } catch (e) {}
    });
  }

  /* ------------------------------------------------------------------------
     2. Videos: lazy, passend zur Bildschirmgroesse, nur wenn sichtbar
     ------------------------------------------------------------------------ */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function startVideo(v) {
    if (!v.getAttribute('src')) {
      v.setAttribute('src', v.getAttribute('data-src'));
      v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function initVideos() {
    if (reduceMotion || saveData) return;
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-s-video]:not([data-s-init])'));
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.setAttribute('data-s-init', '1'); var mq = v.getAttribute('data-mq'); if (!mq || matchMedia(mq).matches) startVideo(v); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        var mq = v.getAttribute('data-mq');
        if (mq && !matchMedia(mq).matches) return;
        if (en.isIntersecting) startVideo(v);
        else if (!v.paused) v.pause();
      });
    }, { rootMargin: '120px 0px', threshold: 0.15 });
    vids.forEach(function (v) { v.setAttribute('data-s-init', '1'); io.observe(v); });
  }

  /* ------------------------------------------------------------------------
     3. Bewertungen: grosse Ansicht (ein natives <dialog> fuer die ganze Seite)
     ------------------------------------------------------------------------ */
  var dlg = null, group = [], idx = 0;
  function ensureDialog() {
    if (dlg) return dlg;
    dlg = document.getElementById('s-lightbox');
    if (!dlg) return null;
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-s-lb-close]')) dlg.close();
      if (e.target.closest('[data-s-lb-prev]')) show(idx - 1);
      if (e.target.closest('[data-s-lb-next]')) show(idx + 1);
    });
    dlg.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    return dlg;
  }
  function show(i) {
    if (!group.length) return;
    idx = (i + group.length) % group.length;
    var b = group[idx];
    var img = b.getAttribute('data-img');
    var t = b.querySelector('template[data-s-review-text]');
    dlg.classList.toggle('s-lightbox--text', !img);
    var im = dlg.querySelector('[data-s-lb-img]');
    if (img) { im.src = img; im.alt = b.getAttribute('data-name') || ''; } else { im.removeAttribute('src'); }
    dlg.querySelector('[data-s-lb-name]').textContent = b.getAttribute('data-name') || '';
    dlg.querySelector('[data-s-lb-date]').textContent = b.getAttribute('data-date') || '';
    var r = parseFloat(b.getAttribute('data-rating') || '5');
    dlg.querySelector('[data-s-lb-stars]').style.setProperty('--s-fill', (r * 20) + '%');
    var tmp = document.createElement('textarea');
    tmp.innerHTML = t ? t.innerHTML : '';
    dlg.querySelector('[data-s-lb-text]').textContent = tmp.value;
    var model = b.getAttribute('data-model') || '';
    var mEl = dlg.querySelector('[data-s-lb-model]');
    mEl.textContent = model; mEl.hidden = !model;
    dlg.querySelector('[data-s-lb-count]').textContent = (idx + 1) + ' / ' + group.length;
  }
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-s-review]');
    if (!card) return;
    if (!ensureDialog()) return;
    var track = card.closest('[data-s-rail]') || document;
    group = Array.prototype.slice.call(track.querySelectorAll('[data-s-review]'));
    show(group.indexOf(card));
    if (typeof dlg.showModal === 'function') { dlg.showModal(); document.documentElement.style.overflow = 'hidden'; }
  });

  /* ------------------------------------------------------------------------
     4. Sanftes Scrollen zu Ankern
     ------------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-s-scroll]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').replace('#', '');
    var t = id && document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    var off = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height'), 10) || 70;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - off - 8, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ------------------------------------------------------------------------
     Start
     ------------------------------------------------------------------------ */
  var moQueued = false;
  var mo = new MutationObserver(function () {
    if (moQueued) return;
    moQueued = true;
    requestAnimationFrame(function () {
      moQueued = false;
      if (document.querySelector('[data-s-delivery]:not([data-done])')) paintDelivery();
      if (document.querySelector('video[data-s-video]:not([data-s-init])')) initVideos();
    });
  });

  function boot() {
    paintDelivery();
    initVideos();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Tab wieder sichtbar: angehaltene, sichtbare Videos weiterspielen
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    document.querySelectorAll('video[data-s-video][src]').forEach(function (v) {
      var b = v.getBoundingClientRect();
      if (v.paused && b.bottom > 0 && b.top < window.innerHeight && b.width > 0) startVideo(v);
    });
  });

  // Abschnitte im Theme-Editor neu geladen
  document.addEventListener('shopify:section:load', function () { paintDelivery(); initVideos(); });
})();